<template>
  <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
    <div
      v-for="card in cards"
      :key="card.title"
      class="rounded-xl bg-gradient-to-br from-accent/10 to-gradient-end/10 p-6 dark:from-accent/20 dark:to-gradient-end/20"
    >
      <h3 class="mb-4 flex items-center text-xl font-semibold text-ternary-dark dark:text-primary-light">
        <span class="mr-3 text-xl">{{ card.emoji }}</span>
        {{ card.title }}
      </h3>
      <ul class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
        <li
          v-for="item in card.items"
          :key="item"
          class="flex items-center"
        >
          <span class="mr-2">{{ getRandomEmoji() }}</span>
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
interface InfoCard {
  title: string
  emoji: string
  items: string[]
}

interface Props {
  cards: InfoCard[]
}

defineProps<Props>()

// Simple emoji picker for variety
function getRandomEmoji () {
  const emojis = ['👥', '🎨', '📬', '🔄', '🧠', '🔧', '⏱️', '🌐', '💡', '🚀', '⭐', '🎯']
  return emojis[Math.floor(Math.random() * emojis.length)]
}
</script>
